import React from 'react';
import {Link} from 'react-router';
import UserAvatar from 'components/pure/utils/UserAvatar';

export default props => {
  return (
    <div className="display-name">
      <UserAvatar
        user={props.user}
        enableTooltip={true}
        tooltipDirection="right"
        bustImageCache={true}
      />
      <Link to={`/admin/users/edit/${props.user.id}`} className="user-name generic-link">
        {props.user.displayName}
      </Link>
    </div>
  );
};
